<div
	class="testquestions-tbl"
	[dir]="isLtr ? 'ltr' : 'rtl'"
>
	@if (is_locked == "no" && is_public !== "yes") {
		<ng-container
			*ngTemplateOutlet="
				newFields;
				context: { curRow: newTestquestion, isNewRow: true }
			"
		/>
	}

	@for (testquestion of testquestions; track testquestion) {
		<ng-container
			*ngTemplateOutlet="newFields; context: { curRow: testquestion }"
		/>
	}
</div>
<ng-template
	#newFields
	let-curRow="curRow"
	let-isNewRow="isNewRow"
>
	<div
		[class.new-row]="isNewRow"
		class="card-container pb-3"
		style="border-bottom: 1px solid var(--dark-green)"
	>
		<div class="card-wrapper">
			@if (is_public !== "yes") {
				@if (!isNewRow && is_locked == "no") {
					<div>
						<!-- <div class="d-flex gap-2 align-items-center"> -->
						<app-spin-or-content [isSpin]="curRow.isFlipOrderSending">
							<div class="up-down-wrapper">
								@if (!curRow.is_lowest_order) {
									<app-icon
										icon="arrow_up"
										(click)="moveOrderNum(curRow, true)"
										titleLang="forward"
									/>
								}
								@if (!curRow.is_highest_order) {
									<app-icon
										icon="arrow_down"
										(click)="moveOrderNum(curRow, false)"
										titleLang="backward"
									/>
								}
							</div>
						</app-spin-or-content>
					</div>
				}
			}
			<div class="question d-grid gap-2 flex-grow-1">
				<!-- <label>{{ "question" | langVal }}</label> -->
				<app-wysiwyg
					#firstField
					fieldName="question"
					[actualObj]="curRow"
					[errors]="curRow.errors"
					[isStatic]="is_locked == 'yes' || is_public == 'yes'"
					(keyupEvent)="validateEntireForm(curRow, true)"
					(changeEvent)="validateEntireForm(curRow)"
				/>
				<div
					class="d-flex flex-column flex-md-row gap-2 flex-grow-1"
					style="align-self: flex-start"
				>
					@if (curRow.field_type == "number") {
						<div
							class="answer-suboptions number gap-2 flex-grow-1"
							style="display: grid"
						>
							<div class="d-flex gap-4">
								<div class="colstat-small">
									<label>{{ "range_min" | langVal }}</label>
									<app-gen-input
										fieldName="range_min"
										isNumber
										[actualObj]="curRow"
										[errors]="curRow.errors"
										[disabled]="is_locked == 'yes' || is_public == 'yes'"
										(keyupEvent)="validateEntireForm(curRow, true)"
										(changeEvent)="validateEntireForm(curRow)"
									/>
								</div>

								<div class="colstat-small">
									<label>{{ "range_max" | langVal }}</label>
									<app-gen-input
										fieldName="range_max"
										isNumber
										[actualObj]="curRow"
										[errors]="curRow.errors"
										[disabled]="is_locked == 'yes' || is_public == 'yes'"
										(keyupEvent)="validateEntireForm(curRow, true)"
										(changeEvent)="validateEntireForm(curRow)"
									/>
								</div>
							</div>

							<!--						<div class="colstat-small"><label>{{ "correct_answer" | langVal }}</label>-->
							<!--							<app-gen-input fieldName="" type="number" [actualObj]="curRow" [errors]="curRow.errors"-->
							<!--								[disabled]="is_locked == 'yes'" (keyupEvent)="validateEntireForm(curRow, true)"-->
							<!--								(changeEvent)="validateEntireForm(curRow)" />-->
							<!--						</div>-->
						</div>
					}

					@if (
						curRow.field_type != "number" &&
						curRow.field_type != "text" &&
						curRow.field_type != "remark"
					) {
						<div class="answer-suboptions d-flex flex-column gap-2 flex-grow-1">
							<!-- <app-table-wrap fieldsStr="order_num,vvalue,mark,action"> -->
							@for (opt of curRow.optionsArr; track opt) {
								<div class="d-flex gap-4 align-items-end">
									@if (is_locked == "no" && is_public !== "yes") {
										<div class="up-down-wrapper actions sort-action">
											@if (opt.order_num > 1) {
												<app-icon
													icon="arrow_up"
													(click)="moveOptOrderNum(curRow, opt, true)"
												/>
											}
											@if (!opt.is_highest_order) {
												<app-icon
													icon="arrow_down"
													(click)="moveOptOrderNum(curRow, opt, false)"
												/>
											}
										</div>
									}
									<div class="flex-grow-1">
										<label>{{ "vvalue" | langVal }}</label>
										<app-gen-input
											#optValue
											fieldName="value"
											[actualObj]="opt"
											title_ph_lang="vvalue"
											[disabled]="is_locked == 'yes' || is_public == 'yes'"
											[dataRowField]="(curRow?.id || 0) + '_' + opt.order_num"
											(changeEvent)="validateEntireForm(curRow)"
											(keyupEvent)="validateEntireForm(curRow, true)"
										/>
									</div>
									@if (isCalculated) {
										<div>
											<label>{{ "mark" | langVal }}</label>
											<app-gen-input
												fieldName="mark"
												isNumber
												min="0"
												max="100"
												[actualObj]="opt"
												[disabled]="is_locked == 'yes' || is_public == 'yes'"
												(changeEvent)="validateEntireForm(curRow)"
												(keyupEvent)="validateEntireForm(curRow, true)"
											/>
										</div>
									}
									<div>
										@if (is_locked == "no" && is_public == "no") {
											<button
												class="btn btn-icon"
												tabindex="-1"
												(click)="removeOpt(curRow, opt)"
												icon="delete"
											></button>
										}
									</div>
								</div>
							}
							@if (is_locked == "no" && is_public == "no") {
								<div
									class="d-flex mx-4"
									style="text-align: center; margin-top: 23px"
								>
									<button
										class="btn btn-primary"
										(click)="addOpt(curRow)"
										tabClick
									>
										{{ "add_option" | langVal }}
									</button>
								</div>
							}
							<!-- </app-table-wrap> -->

							@if (curRow.errors?.options) {
								<p class="error">{{ curRow.errors?.options }}</p>
							}
						</div>
					}
				</div>
			</div>
			<div class="card-options d-grid gap-3 px-2 pad-btns">
				<div class="answer-type colstat-small">
					<label>{{ "field_type" | langVal }}</label>
					<app-gen-select
						optionFieldId="value"
						[actualObj]="curRow"
						[disabled]="is_locked == 'yes' || is_public == 'yes'"
						fieldName="field_type"
						(changeEvent)="validateEntireForm(curRow)"
						optionsListName="testquestion_field_types"
					/>
				</div>
				@if (isCalculated && !["text", "number"].includes(curRow.field_type)) {
					<div class="colstat-small">
						<label>{{ "question_num" | langVal }}</label>
						<app-gen-input
							fieldName="question_num"
							isNumber
							min="1"
							[actualObj]="curRow"
							[errors]="curRow.errors"
							[disabled]="is_locked == 'yes' || is_public == 'yes'"
							(keyupEvent)="validateEntireForm(curRow, true)"
							(changeEvent)="validateEntireForm(curRow)"
						/>
					</div>
				}
				<div
					class="answer-required"
					style="margin-inline-start: auto; min-width: 130px"
				>
					<!--				<app-gen-button-group-->
					<!--					[actualObj]="curRow"-->
					<!--					fieldName="required"-->
					<!--					[disabled]="is_locked == 'yes' || is_public == 'yes'"-->
					<!--					optionsListName="requiredOpts"-->
					<!--					title_ph_lang="required"-->
					<!--					(changeEvent)="validateEntireForm(curRow)"-->
					<!--				/>-->
					<div class="switch-btn switch-btn-subtle">
						<app-yes-no
							(onClick)="handleRequiredChange(curRow)"
							[disabled]="is_locked == 'yes' || is_public == 'yes'"
							[isCheck]="curRow.required == 'yes'"
							title_ph_lang="required"
						/>
						<label (click)="handleRequiredChange(curRow)">
							{{ "required" | langVal }}
						</label>
					</div>
				</div>
			</div>
		</div>
		<div class="w-100 d-flex mis-auto">
			<app-spin-or-content
				[isSpin]="curRow.isDeleting"
				style="margin-inline-start: auto"
			>
				@if (isNewRow) {
					<app-btn-ext
						text="add"
						(clickEv)="saveNewTestquestion()"
						[disabled]="!curRow.isFormSubmittable"
						[isSpin]="isNewSaving"
					/>
				} @else {
					@if (is_locked == "no" && is_public == "no") {
						<button
							class="btn btn-icon"
							(click)="deleteTestquestion(curRow)"
							titleLang="delete"
							icon="delete"
						></button>
					}
				}
			</app-spin-or-content>
		</div>
	</div>
</ng-template>
@switch (modalProps?.name) {
	@case ("confirm-delete") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="do_you_confirm_delete"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="handleDeleteApprove($event)"
				[objectName]="modalProps.objectName"
			/>
		</app-modal-wrap>
	}
}
